import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import dayjs from "dayjs";
import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useEffect, useState } from "react";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Admin from "../../components/auth/Admin";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableHead,
  TextField,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Notification from "../../components/customHelpers/Notification";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { getTimestamp } from "../../utils/utils";
import Organization from "../../actions/organization";
const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const initialHeadCells = [
  { id: "activity", label: "Activity", isVisible: true },
  { id: "staff", label: "Staff", isVisible: true },
  { id: "organization", label: "Organization", isVisible: true },
  { id: "createdAt", label: "Date", isVisible: true },
];

const ActivityLog = () => {
  const classes = useStyles();
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllActivity, viewAllStaffs } = Organization();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [activitys, setActivitys] = useState([]);
  const [tempActivity, setTempActivity] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [staffs, setStaffs] = useState([]);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const pageSizes = [15, 25, 50, 100];
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllActivity();
  }, [page, limit, searchQuery, startDate, endDate, selectedStaff]);
  useEffect(() => {
    getAllStaffs();
  }, []);
  const getAllActivity = () => {
    setValues({ ...values, loading: true });
    viewAllActivity(
      page,
      limit,
      searchQuery,
      startDate,
      endDate,
      selectedStaff?.fullName
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.activity) {
        setValues({
          ...values,
          loading: false,
        });
        setActivitys(data.activity);
        setTempActivity(data.activity);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };

  const getAllStaffs = () => {
    setValues({ ...values, loading: true });
    viewAllStaffs().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.staffs) {
        setValues({
          ...values,
          loading: false,
        });
        setStaffs(data.staffs);
      }
    });
  };
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(activitys, initialHeadCells, filterFn);

  const handleStartDateChange = (newValue) => {
    setPage(1);
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue) => {
    setPage(1);
    setEndDate(newValue);
  };
  const generateReportFilename = (startDate, endDate, staffName, timestamp) => {
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "AllDates";
    const formattedEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
    const formattedStaffName = staffName ? staffName : "AllStaff";

    return `${formattedStartDate}_${formattedEndDate}_${formattedStaffName}_Activity-log-report_${timestamp}`;
  };

  const exportToExcel = () => {
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);
    const dataToExport = activitys.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "activity":
            return item.activity;
          case "staff":
            return item.staff?.fullName;
          case "organization":
            return item.organization?.organization_name;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );

    const worksheet = XLSX.utils.aoa_to_sheet([
      filteredHeadCells.map((cell) => cell.label),
      ...dataToExport,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Order");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedStaff?.fullName,
      timestamp
    );
    saveAs(blob, `${filename}.xlsx`);
    handleClose();
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    const filteredHeadCells = headCells.filter((cell) => cell.isVisible);

    // Prepare the data for the table
    const bodyData = activitys.map((item) =>
      filteredHeadCells.map((cell) => {
        switch (cell.id) {
          case "activity":
            return item.activity;
          case "staff":
            return item.staff?.fullName;
          case "organization":
            return item.organization?.organization_name;
          case "createdAt":
            return new Date(item.createdAt).toLocaleString();
          default:
            return "";
        }
      })
    );
    doc.autoTable({
      head: [filteredHeadCells.map((cell) => cell.label)],
      body: bodyData,
      styles: {
        fontSize: 10,
      },
      headStyles: {
        fillColor: [244, 151, 3],
        textColor: [20, 61, 89],
      },
    });

    const timestamp = getTimestamp();
    const filename = generateReportFilename(
      startDate,
      endDate,
      selectedStaff?.fullName,
      timestamp
    );
    doc.save(`${filename}.pdf`);
    handleClose();
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const clearFilters = () => {
    setPage(1);
    setStartDate(null);
    setEndDate(null);
    setInputValue("");
    setSelectedStaff(null);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [inputValue, setInputValue] = useState("");
  const filteredOptions = staffs?.filter((option) =>
    option.fullName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleSearchChange = (event, value) => {
    if (value) {
      setSelectedStaff(value);
      setPage(1);
    }
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Activity Log Report
          </Typography>

          <Box display="flex" justifyContent="center" gap={2} m={1} p={1}>
            <Box mb={-10}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    format="DD-MM-YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "DatePicker"]}>
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={handleEndDateChange}
                  slotProps={{
                    field: {
                      clearable: true,
                      onClear: () => setActivitys(tempActivity),
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <Box sx={{ width: "25%", m: 1 }}>
              <Autocomplete
                options={searchTerm ? filteredOptions : []}
                fullWidth
                getOptionLabel={(option) => option.fullName}
                onChange={handleSearchChange}
                onInputChange={(event, newInputValue) =>
                  setInputValue(newInputValue)
                }
                value={selectedStaff} // Set the selected value
                inputValue={inputValue}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Staff Name"
                    variant="outlined"
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                )}
              />
            </Box>
            <Box display="flex" justifyContent="end" gap={2} m={1}>
              <Box>
                <Button
                  variant="contained"
                  onClick={clearFilters}
                  startIcon={<ClearAllIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)", // Darker on hover
                    },
                  }}
                >
                  Clear
                </Button>
              </Box>
              <Box sx={{ width: "27%" }}>
                <Button
                  variant="contained"
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  startIcon={<DownloadIcon />}
                  sx={{
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                    "&:hover": {
                      backgroundColor: "rgba(244,151,3,.8)",
                      color: "rgb(20,61,89)", // Darker on hover
                    },
                  }}
                >
                  Export
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={exportToPDF}>PDF</MenuItem>
                  <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                </Menu>
              </Box>
            </Box>{" "}
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterSortingAndFiltering().length > 0 ? (
                        recordsAfterSortingAndFiltering().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.activity}</TableCell>
                            <TableCell>{item?.staff?.fullName}</TableCell>
                            <TableCell>
                              {item.organization?.organization_name}
                            </TableCell>
                            <TableCell>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {activitys.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || activitys.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={activitys.length === 0}
                      />
                    )}
                  </Box>{" "}
                </Paper>
              )}
            </Grid>
            <Notification notify={notify} setNotify={setNotify} />
          </Grid>
        </div>
      </Admin>
    </Layout>
  );
};

export default ActivityLog;
